import {OptimizeByValue} from 'common/src/modules/optimization/optimization.types';

/**
 * Check if the given optimizeBy value supports attribution signals.
 * Only Conversions and ClickThroughConversions support attribution signals.
 */
function supportsAttributionSignals(optimizeBy: OptimizeByValue): boolean {
  return [OptimizeByValue.Conversions, OptimizeByValue.ClickThroughConversions].includes(
    optimizeBy,
  );
}

export default supportsAttributionSignals;
